<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';

const auth = useAuthStore();

// На старте SPA — пробуем восстановить сессию через GET /api/session/me.
// Если cookie валидна → auth.user заполнится, router guard пропустит на
// защищённые маршруты. Иначе пользователь увидит LoginView.
onMounted(async () => {
  await auth.bootstrap();
});
</script>

<template>
  <Toast position="top-right" />
  <ConfirmDialog />
  <router-view />
</template>

<style>
/* Глобальные стили вынесены в styles/main.css. App.vue — только layout. */
</style>
